import { initialState } from '../initial';
import type { CampaignEditorReducerCreator } from '../types';

const resetCampaignEditor = (create: CampaignEditorReducerCreator) => create.reducer(() => initialState);

export default resetCampaignEditor;
